import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'nika-datepicker',
  template: `<div class="nika-datepicker">
	<mat-form-field>
		<input matInput autocomplete="off"
			   [placeholder]="placeholder"
			   [required]="required"
			   [disabled]="disabled"
			   [(ngModel)]="valueSt"
			   (ngModelChange)="isValueStChange = true"
			   (keyup.enter)="changeValueSt(); genValueSt(); changed();"
			   (click)="picker.open();">
		<mat-hint class="nika-datepicker-error" align="end" *ngIf="validationError">{{validationError}}</mat-hint>
	</mat-form-field>

	<mat-form-field class="nika-datepicker-sp">
		<input matInput autocomplete="off" [matDatepicker]="picker"
			   [placeholder]="placeholder"
			   [required]="required"
			   [disabled]="disabled"
			   [(ngModel)]="value_"
			   (ngModelChange)="genValueSt(); changed();">
		<mat-datepicker #picker></mat-datepicker>
	</mat-form-field>

	<div class="nika-datepicker-actions">
		<span class="mdi mdi-subdirectory-arrow-left mdi-24px" *ngIf="isValueStChange"
			  (click)="changeValueSt(); genValueSt(); changed();"></span>
	</div>
</div>
`,
  styles: [`.nika-datepicker{position:relative}.nika-datepicker mat-form-field{width:100%;margin-top:0}.nika-datepicker-sp{overflow:hidden;width:0;height:0;position:absolute;top:0;left:0}.nika-datepicker-error{color:red}.nika-datepicker-actions{position:absolute;right:0;top:12px;line-height:30px}.nika-datepicker-actions span{color:#adadb3;cursor:pointer;transition:150ms}.nika-datepicker-actions span:hover{color:#6b6b77}`]
})
export class DatePickerComponent implements OnInit {
  public value_ = null;
  public valueSt: string;
  public isValueStChange = false;

  @Input() placeholder: string;
  @Input() required: boolean;
  @Input() disabled: boolean;
  @Input() validationError: any;

  @Input() set value(value: any) {
    if (this.value_ !== value) {
      this.value_ = value;
      this.genValueSt();
    }
  }

  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  constructor() {
  }

  ngOnInit() {
    this.genValueSt();
  }

  // Ð³ÐµÐ½ÐµÑÐ°ÑÐ¸Ñ Ð´Ð°ÑÑ Ð²Ð²Ð¸Ð´Ðµ Ð¾Ð±ÑÑÐ½Ð¾Ð¹ ÑÑÑÐ¾ÐºÐ¸
  public genValueSt() {
    if (this.value_) {
      this.valueSt = ('00' + this.value_.getDate()).slice(-2) + '.' +
          ('00' + (this.value_.getMonth() + 1)).slice(-2) + '.' +
          this.value_.getFullYear();
    } else {
      this.valueSt = '';
    }
  }

  // Ð³ÐµÐ½ÐµÑÐ°ÑÐ¸Ñ Ð¾Ð±ÑÐµÐºÑÐ° Ð´Ð°ÑÑ Ð¿ÑÐ¸ ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ð¸ ÑÑÑÐ¾ÐºÐ¸
  public changeValueSt() {
    const re = /(\d{1,2}).(\d{1,2}).(\d{4})/i;
    const re2 = /(\d{1,2}).(\d{1,2}).(\d{2})/i;
    const res = this.valueSt.match(re);
    const res2 = this.valueSt.match(re2);

    if (res) {
      if (res[1].length === 1) {
        res[1] = '0' + res[1];
      }
      if (res[2].length === 1) {
        res[2] = '0' + res[2];
      }

      this.value_ = new Date(new Date(res[3] + '-' + res[2] + '-' + res[1]).toDateString());
    } else if (res2) {
      if (res2[1].length === 1) {
        res2[1] = '0' + res2[1];
      }
      if (res2[2].length === 1) {
        res2[2] = '0' + res2[2];
      }

      this.value_ = new Date(new Date('20' + res2[3] + '-' + res2[2] + '-' + res2[1]).toDateString());
    }
  }

  public changed() {
    this.valueChange.emit(this.value_);
    this.isValueStChange = false;
  }
}
